import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import VueDragscroll from 'vue-dragscroll';
import { Amplify } from 'aws-amplify';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

// import awsconfig from './aws-exports';

const awsconfig = {
  aws_project_region: process.env.VUE_APP_AWS_PROJECT_REGION,
  aws_appsync_graphqlEndpoint: process.env.VUE_APP_AWS_APPSYNC_GRAPHQLENDPOINT,
  aws_appsync_region: process.env.VUE_APP_AWS_APPSYNC_REGION,
  aws_appsync_authenticationType: process.env.VUE_APP_AWS_APPSYNC_AUTHENTICATION_TYPE,
  aws_appsync_apiKey: process.env.VUE_APP_AWS_APPSYNC_API_KEY
};

Amplify.configure(awsconfig);

Vue.config.productionTip = false;
Vue.use(VueCompositionAPI);
Vue.use(VueDragscroll);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
